import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { SubscriptionCoupon } from 'src/app/classes/SubscriptionCoupon';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
};

@Injectable({
  providedIn: 'root',
})
export class SubscriptionCouponsService {

  constructor(private httpClient: HttpClient) {
  }

  public getAll(): Observable<SubscriptionCoupon[]> {
    const options = status ? {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
    } : httpOptions;
    return this.httpClient.get<SubscriptionCoupon[]>(`${environment.backendApiUrl}/v1/subscription-coupons`, options);
  }

  public add(coupon: SubscriptionCoupon): Observable<void> {
    return this.httpClient.post<void>(`${environment.backendApiUrl}/v1/subscription-coupons`, coupon, httpOptions);
  }

  public edit(coupon: SubscriptionCoupon): Observable<void> {
    return this.httpClient.put<void>(`${environment.backendApiUrl}/v1/subscription-coupons`, coupon, httpOptions);
  }

  public delete(id: number): Observable<void> {
    return this.httpClient.delete<void>(`${environment.backendApiUrl}/v1/subscription-coupons/` + id, httpOptions);
  }
}
